import React, {Component} from 'react'
import Table from '../../tables/reactable/DefaultTable'

class OfferList extends Component {
  constructor() {
    super()
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this)
    this.onSearch = this.onSearch.bind(this)
    this.onFilter = this.onFilter.bind(this)
    this.state = {
      itemsPerPage: 10,
      openBtnVisible: true,
      openBtnLabel: 'View',
      search: '',
      filter: {
        CanBook: 'true',
        City: ''
      }
    }
    this.columns = [
      'Poster',
      'Production',
      'ClientImageUrl',
      'ProductionForSearch',
      'SkillType',
      'Description',
      'StartDate',
      'NumberOfCandidates',
      'WorkAmountQuantity',
      'CanBook',
      'ClientName'
    ]
    this.columnNames = [
      '',
      'Production',
      'Client',
      'ProductionForSearch',
      'Speciality',
      'Description',
      'Schedule',
      'Candidates',
      'Offered work',
      'CanBook',
      'ClientName'
    ]
  }

  onChangeItemsPerPage(e) {
    e.preventDefault()
    this.setState({
      itemsPerPage: e.target.value
    })
    return false
  }

  onSearch(e) {
    e.preventDefault()
    this.setState({
      search: e.target.value
    })
    return false
  }

  onFilter(filter) {
    this.setState({
      filter: filter
    })
  }

  getCities(items){
    var uniqueCities = new Set();
    items.forEach(item => {
      uniqueCities.add(item['City'])
    });
    if(uniqueCities.size > 1){
      return Array.from(uniqueCities).map(city => {
        return {
          label: city,
          value: city.toLowerCase()
        }
      });
    }
    return [];
  }

  render() {
    let items = this.props.items.map(item => {
      return Object.assign({}, item, {
        Poster: item.PosterUrl ? (<img src={item.PosterUrl} style={{width: '50px'}} alt="" />) : (null),
        Production: item.ProductionId ? (<a href={'/productions/' + item.ProductionId + '/overview'} title={item.Title}>{item.Title}</a>): (null),
        ClientImageUrl: item.ClientImageUrl ? (<img src={item.ClientImageUrl} style={{borderRadius: '50%', width: '50px'}} alt="" />) : (<div title={item.ClientName} className="firstLetterCircle">{item.ClientName.charAt(0)}</div>),
        ProductionForSearch: item.Title,
        StartDate: item.StartDate ? (<span startdate={item.StartDate}>{item.Schedule}</span>): (null),
        WorkAmountQuantity: item.WorkAmountQuantity ? (<span quantity={item.WorkAmountQuantity}>{item.WorkAmount}</span>) : (null),
        NumberOfCandidates: item.NumberOfCandidates ? (item.PreHiredCandidateId ? <a href={'/talents/' + item.PreHiredCandidateId + '/overview'}>{item.PreHiredCandidateFullName}</a>:<span>{item.NumberOfCandidates}</span>):(null)
      })
    });

    return (
      <div>
        <Table
          items={items}
          columns={this.columns}
          hiddenColumns={[
            'ProductionForSearch',
            'CanBook',
            'ClientName'
          ]}
          columnNames={this.columnNames}
          itemsPerPage={this.state.itemsPerPage}
          searchable={[
            'ProductionForSearch',
            'SkillType',
            'Description',
            'ClientName'
          ]}
          search={this.state.search}
          onSearch={this.onSearch}
          filterable={[{
              column: 'CanBook',
              filters: [
                {
                  value: 'true',
                  label: 'Only offers I can book'
                }
              ]
            },
            {
              column: 'City',
              filters: this.getCities(items)
          }]}
          filter={this.state.filter}
          onFilter={this.onFilter}
          onChangeItemsPerPage={this.onChangeItemsPerPage}
          openBtnVisible={this.state.openBtnVisible}
          openBtnLabel={this.state.openBtnLabel}
          openBtnHref="/{NavigationParam}/overview"
          sortable={[
            {
              column: 'Production',
              sortFunction: function(a, b) {
                return a.props ? a.props.children.localeCompare(b.props.children): 0;
              }
            },
            'SkillType',
            'Description',
            'NumberOfCandidates',
            {
              column: 'WorkAmountQuantity',
              sortFunction: function(a, b) {
                return a.props.quantity === b.props.quantity ? 0 : (a.props.quantity < b.props.quantity ? 1 : -1);
              }
            },
            {
              column: 'StartDate',
              sortFunction: function(a, b) {
                return a.props ? a.props.startdate.localeCompare(b.props.startdate): 0;
              }
            }
          ]}
          defaultSort={{column: 'StartDate', direction: 'desc'}}
        />
      </div>
    )
  }
}

export default OfferList
